<div [ngClass]="[color() ? 'color' + color() : '']">
	<ng-content></ng-content>
</div>
